import posed from 'react-pose';


let AnimatedDivSlideUp = posed.div({
    visibleSlideUp: {
        opacity: 1,
        y:'0%',
        transition: {
            ease:[0.530, 0.035, 0.070, 1.290],
            duration: 250,
        }
    },
    hiddenSlideUp: {
        opacity: .5,
        y:'20%',
        transition: {
            ease:[0.530, 0.035, 0.070, 1.290],
            duration: 250,
        }
    }
});

export default AnimatedDivSlideUp;



// WEBPACK FOOTER //
// ./src/animations/src/AnimatedDivSlideUp.js